/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import cn from "clsx";
import { useSimpliCity } from "cms/hooks/use-simplicity";

const MobileDropdownMenu = (props) => {

    const show = props?.show ?? false;

    const { menu } = useSimpliCity();
    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenuItemDropdown = (title) => {
        if (title === openMenu) {
            setOpenMenu(null);
        } else {
            setOpenMenu(title);
        }
    };

    if (!show) {
        return null;
    }

    return (
        <div className="mobile-dropdown-menu">
            <ul>
                {menu.map((item, index) => {
                    const childMenus = item?.children ?? [];
                    const title = item?.title ?? "";
                    const url = item?.url ?? "";
                    const showMenuItemDropdown = openMenu === title;
                    const level1ItemClassName = cn(
                        "mobile-menu-item-level-1",
                        { "expanded": showMenuItemDropdown }
                    );
                    return (
                        <li key={`mobile-menu-item-${index}`}>
                            <a href={url} className={level1ItemClassName}>
                                <span>{title}</span>
                            </a>
                            <button onClick={() => toggleMenuItemDropdown(title)}>
                                {showMenuItemDropdown && "-"}
                                {!showMenuItemDropdown && "+"}
                            </button>
                            {showMenuItemDropdown &&
                                <div className="mobile-menu-item-dropdown">
                                    <ul>
                                        {childMenus.map((child, idx) => {
                                            const childTitle = child?.title ?? "";
                                            const childUrl = child?.url ?? "";
                                            return (
                                                <li key={`child-menu-item-${idx}`}>
                                                    <a href={childUrl}>
                                                        {childTitle}
                                                    </a>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            }
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export { MobileDropdownMenu };
